import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { User } from '../models/user';
import { LocalStorageService } from '../services/local-storage-service';
import { SharedDataService } from '../services/shared-data.service';

let defaultState = {
  user: null,
};

@Injectable({
  providedIn: 'root',
})
export class UserSubscriber {
  private _store = new BehaviorSubject<any>(defaultState);
  private _state$ = this._store.asObservable();

  constructor(
    private _localStorageService: LocalStorageService,
    private _sharedDataService: SharedDataService
  ) {}

  user$ = this._state$.pipe(
    map((s) => s.user),
    distinctUntilChanged()
  );

  getUser(): User {
    return this._store.value.user;
  }

  setSelectedDepartment(departmentName: string): void {
    const user = this.getUser();
    user.selectedDepartment = user.getUserSelectedDepartment(departmentName);
    this.setUser(new User(user));
  }

  setUser(user: User): void {
    this.updateState({ ...defaultState, user });
  }

  updateState(state: any): void {
    this._store.next((defaultState = state));
  }

  handleUserDepartment(user: User): void {
    const department = this._localStorageService.getItem('selectedDepartment');
    const departments = user.departments.map(d => d.department);
    const userHasDepartment = departments.includes(department);

    if ((!department || !userHasDepartment) || (department && !userHasDepartment)) {
      const defaultDept = user.getUserDefaultDepartment();
      user.selectedDepartment = user.getUserSelectedDepartment(defaultDept);
      this._localStorageService.setItem('selectedDepartment', user.selectedDepartment);
      this._localStorageService.setItem('theme', user.getUserTheme(user.selectedDepartment));
      this._sharedDataService.userIsAdmin = user.isUserAdmin(user.selectedDepartment);
    } else {
      user.selectedDepartment = department;
      this._localStorageService.setItem('selectedDepartment', user.selectedDepartment);
      this._localStorageService.setItem('theme', user.getUserTheme(user.selectedDepartment));
      this._sharedDataService.userIsAdmin = user.isUserAdmin(user.selectedDepartment);
    }

    this.setUser(user);
  }
}
